export default __webpack_public_path__ + "static/showerHead-dfbd73be9692f6735384c54c4d75303c.webp";